var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tagType == "checkbox"
    ? _c(
        "a-checkbox-group",
        {
          attrs: { value: _vm.arrayValue, disabled: _vm.disabled },
          on: { change: _vm.onChange }
        },
        [
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey === undefined ||
              item.langKey === null ||
              item.langKey === ""
              ? _c("a-checkbox", { key: key, attrs: { value: item.value } }, [
                  _vm._v(_vm._s(item.text || item.label))
                ])
              : _vm._e()
          }),
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey !== undefined &&
              item.langKey !== null &&
              item.langKey !== ""
              ? _c("a-checkbox", { key: key, attrs: { value: item.value } }, [
                  _vm._v(_vm._s(_vm.language[item.langKey] || item.text))
                ])
              : _vm._e()
          })
        ],
        2
      )
    : _vm.tagType == "select"
    ? _c(
        "a-select",
        {
          attrs: {
            value: _vm.arrayValue,
            disabled: _vm.disabled,
            mode: "multiple",
            placeholder: _vm.placeholder,
            getPopupContainer: _vm.isPopup ? _vm.getParentContainer : null,
            optionFilterProp: "children",
            filterOption: _vm.filterOption,
            "show-search": _vm.showSearch,
            showArrow: "",
            maxTagCount: _vm.maxTagCount,
            allowClear: ""
          },
          on: { change: _vm.onChange, focus: _vm.onFocus }
        },
        [
          _vm._l(_vm.dictOptions, function(item, index) {
            return item.langKey === undefined ||
              item.langKey === null ||
              item.langKey === ""
              ? _c(
                  "a-select-option",
                  { key: index, attrs: { value: item.value } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "inline-block", width: "100%" },
                        attrs: { title: item.text || item.label }
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(item.text || item.label) +
                            "\n    "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          _vm._l(_vm.dictOptions, function(item, index) {
            return item.langKey !== undefined &&
              item.langKey !== null &&
              item.langKey !== ""
              ? _c(
                  "a-select-option",
                  { key: index, attrs: { value: item.value } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "inline-block", width: "100%" },
                        attrs: { title: _vm.language[item.langKey] }
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.language[item.langKey]) +
                            "\n    "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }